(function () {
	'use strict';

	angular.module('trakeyeApp').factory('CaseImport', ['$http', function ($http) {

		var service = {};
		service.get = function (data,callback) {
			$http.post('api/casesimportrequests',data).then(function (response) {
				callback(response.data);
			}); 
		};
		return service;
	}]);
})(); 

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('CaseImportList', ['$http', function ($http) {

        var service = {};

        service.get = function (page, size, sort, callback) {

			// 🔥 HANDLE OLD CALL STYLE
			if (typeof page === 'function') {
				callback = page;
				page = 0;
				size = 10;
				sort = 'id,desc';
			}

			page = (typeof page === 'number') ? page : 0;
			size = (typeof size === 'number') ? size : 10;
			sort = sort || 'id,desc';

			var url = 'api/casesimportrequests?page=' + page + '&size=' + size + '&sort=' + sort;

			$http.get(url).then(function (response) {

				if (typeof callback === 'function') {
					callback(response.data, response.headers);
				}

			});
		};
        return service;
    }]);
})();
